import type {ComponentProps} from 'react';
import {cn} from '../lib/cn';

export type FormBoxContentProps = ComponentProps<'div'>;

export function Content({children, className, ...props}: FormBoxContentProps) {
  return (
    <div
      className={cn(
        'flex flex-wrap content-start items-start gap-4 self-stretch',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
